export default __webpack_public_path__ + "static/media/favourite-partners.9f075f30.png";